/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { history } from "./store";

const App = ({ store, children }) => (
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>{children}</ConnectedRouter>
    </Provider>
  </React.StrictMode>
);

export default App;
